import React from 'react';
import { CtaButton } from '../ui/CtaButton';
const pills = ['📚 12 capítulos', '📄 +140 páginas', '🇦🇷 Sistema argentino', '📲 PDF digital'];
export function Hero() {
  return <header className="w-full bg-gradient-to-b from-ink-950 via-ink-900 to-pitch" data-id="element-107" data-mp="cvupufilmxsx">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-20 pt-4 text-center md:pb-28" data-id="element-108" data-mp="cy7ch5zaxwcb">
        <span className="inline-block rounded-full bg-brand-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold ring-1 ring-brand-gold/30" data-id="element-109" data-mp="mu0num1abjsi">
          ⚽ Método Fútbol Digital
        </span>
        <h1 className="mt-8 font-display text-4xl font-black leading-[1.08] text-white sm:text-5xl md:text-6xl" data-id="element-110" data-mp="vlu7wig0vcmu">
          Protegé, acompañá y <span className="text-brand-gold" data-id="element-111" data-mp="10k45t0t4src5">potenciá la carrera</span>{' '}
          futbolística de tu hijo
        </h1>
        <video autoPlay loop muted playsInline disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" aria-hidden="true" onContextMenu={e => e.preventDefault()} style={{
        display: 'block',
        margin: '40px auto 8px',
        maxWidth: '260px',
        width: '100%',
        aspectRatio: '1/1',
        objectFit: 'cover',
        borderRadius: '14px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
        pointerEvents: 'none',
        cursor: 'default',
        userSelect: 'none',
        WebkitUserSelect: 'none'
      }} data-id="element-112" data-mp="15mcw1pemdfak">
          <source src="https://cdn.magicpatterns.com/uploads/c9YDGJgN8wkorSVTFF1rd3/Video%20de%20muestra%20del%20producto%20-%20Trim%202.mp4" type="video/mp4" data-id="element-113" data-mp="iohf4w0wupvu" />
        </video>
        <p className="mt-10 max-w-2xl text-base leading-relaxed text-body md:text-lg" data-id="element-114" data-mp="1b4jrd2h6yopo">
          <strong className="font-bold text-white" data-id="element-115" data-mp="16e3cddxq2v17">EL MÉTODO DEL PADRE DEL FUTBOLISTA</strong> reúne
          todo lo que necesitás saber sobre el fútbol juvenil argentino en un solo método práctico y
          completo.
        </p>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-116" data-mp="35la18wxsxm0c">
          {pills.map(pill => <li key={pill} className="rounded-full border border-ink-border bg-ink-card/70 px-4 py-2 text-sm font-semibold text-body" data-id="element-117" data-mp="2qvciiwin5oij">
              {pill}
            </li>)}
        </ul>
        <div className="mt-10" data-id="element-118" data-mp="2hxsg3k91lm6c">
          <CtaButton size="xl" data-id="element-119" data-mp="2mv236t8yllr0">Obtener el método ahora</CtaButton>
        </div>
        <p className="mt-5 text-sm text-subtle" data-id="element-120" data-mp="27x9q07qvx9fz">
          🔒 Pago seguro · ⚡ Acceso inmediato · ✅ Garantía de 7 días
        </p>
      </div>
    </header>;
}